<template>
  <div>
    <CRow>
      <CCol xs="12" lg="10">
        <CCard>
          <CCardHeader>
            <strong>Πελάτης:</strong> {{ title }}
          </CCardHeader>
          <CCardBody>
            <CTabs>
              <CTab title="Γενικές Πληροφορίες" active>
                <CCard>
                  <CCardBody>
                    <CDataTable 
                      striped 
                      small 
                      fixed
                      :items="gen_items" 
                      :fields="fields"
                      :loading="loading"
                    >
                      <template slot="value" slot-scope="data">
                        <td><strong>{{data.item.value}}</strong></td>
                      </template>
                    </CDataTable>
                  </CCardBody>
                </CCard>
                <CCard>
                  <CCardBody>
                    <CDataTable
                      :items="services"
                      :fields="services_fields"
                      :items-per-page="10"
                      pagination
                      column-filter
                      hover
                      :loading="loading"
                    >
                      <template #name="{item}">
                        <td>
                          {{item.name}}
                        </td>
                      </template>
                      <template #consultant="{item}">
                        <td>
                          {{item.consultant}}
                        </td>
                      </template>
                    </CDataTable>
                  </CCardBody>
                </CCard>
              </CTab>
              <CTab title="Υποθέσεις - Επισκέψεις">
                  <CRow class="pt-2 pb-1 pl-3 pr-3" v-if="!signed_deal">
                    <CCol tag="label" sm="9">
                      <strong>Ο πελάτης δεν έχει υπογράψει σύμβαση.</strong>
                      <div class="pt-1"><CButton color="primary" @click="editClient">Επεξεργασία Πελάτη</CButton></div>
                    </CCol>
                  </CRow>
                  <CDataTable
                    :items="filteredItems"
                    :fields="cases_fields"
                    :items-per-page="10"
                    pagination
                    sorter
                    column-filter
                    hover
                    :loading="loading"
                    v-show="signed_deal"
                  >
                  <template #status-filter>
                    <div class="selectFilter">
                      <CSelect
                        :options="statusOptions"
                        :value.sync="selectedOption"
                      />
                    </div>
                  </template>
                  <template #status="{item}">
                    <td>
                      <CBadge :color="item.status.class">{{ item.status.name }}</CBadge>
                    </td>
                  </template>
                  <template #service="{item}">
                    <td>
                      {{ item.service }}
                    </td>
                  </template>
                  <template #service_subcategories="{item}">
                    <td>
                      {{ item.service_subcategories }}
                    </td>
                  </template>
                  <template #edit="{item}">
                    <td>
                      <CButton color="primary" @click="editCase( item.id )">Επεξεργασία</CButton>
                    </td>
                  </template>
                  <template #bill_status-filter>
                    <div class="selectFilter">
                      <CSelect
                        :options="billStatusOptions"
                        :value.sync="selectedBillOption"
                      />
                    </div>
                  </template>
                </CDataTable>
                <div v-if="signed_deal" class="pt-3 pl-3 pr-3">
                  <strong class="pb-3">Προσθήκη Υπόθεσης</strong>
                  <CreateCase 
                    @added-case="getClient()" 
                    :services="services"
                    v-if="dataReady"
                  />
                </div>
              </CTab>
              <CTab title="Οικονομικά Στοιχεία">
                <CCard>
                  <CCardBody>
                    <CDataTable 
                      striped 
                      small 
                      fixed
                      :items="fin_items" 
                      :fields="fields"
                    >
                      <template slot="value" slot-scope="data">
                        <td><strong>{{data.item.value}}</strong></td>
                      </template>
                    </CDataTable>
                  </CCardBody>
                </CCard>
              </CTab>
              <CTab title="Αρχεία Πελάτη">
                <ClientMedia />
              </CTab>
              <CTab title="Πιστοποιητικά">
                <CDataTable
                    :items="certifications"
                    :fields="certifications_fields"
                    :items-per-page="10"
                    pagination
                    column-filter
                    table-filter
                    hover
                    :loading="loading"
                    sorter
                  >
                  <template #edit="{item}">
                    <td>
                      <CButton color="primary" @click="editCert( item.id )">Επεξεργασία</CButton>
                    </td>
                  </template>
                </CDataTable>
              </CTab>
              <CTab title="Τιμολόγια">
                <CDataTable
                    :items="invoices"
                    :fields="invoices_fields"
                    :items-per-page="10"
                    pagination
                    column-filter
                    table-filter
                    hover
                    :loading="loading"
                    sorter
                  >
                  <template #total_price="{item}">
                    <td>
                      {{ item.total_price }}€
                    </td>
                  </template>
                  <template #payment_status="{item}">
                    <td>
                      {{ payment_options[parseInt(item.payment_status)] }}
                    </td>
                  </template>
                  <template #remaining="{item}">
                    <td>
                      {{ item.remaining }}€
                    </td>
                  </template>
                  <template #payment_comment="{item}">
                    <td>
                      {{ item.payment_comment ? item.payment_comment : '' }}
                    </td>
                  </template>
                </CDataTable>
              </CTab>
            </CTabs>
          </CCardBody>
          <CCardFooter>
            <CButton color="primary" @click="goBack">Πίσω</CButton>
          </CCardFooter>
        </CCard>
      </CCol>
    </CRow>
  </diV>
</template>



<script>
const invoices_fields = [
  { 
    key: 'document_number', 
    label: 'Αριθμός Παραστατικού'
  },
  { 
    key: 'service', 
    label: 'Υπηρεσία'
  },
  { 
    key: 'total_price', 
    label: 'Ποσό'
  },
  { 
    key: 'payment_status', 
    label: 'Κατάσταση πληρωμής'
  },
  { 
    key: 'remaining', 
    label: 'Υπόλοιπο'
  },
  { 
    key: 'payment_comment', 
    label: 'Σχόλιο'
  },
]
import axios from 'axios'
import ClientMedia from './ClientMedia'
import CreateCase from '../cases/CreateCase'
export default {
  name: 'Client',
  components: {
    ClientMedia,
    CreateCase
  },
  data: () => {
    return {
      gen_items: [],
      fin_items: [],
      cases: [],
      services: [],
      signed_deal: false,
      title: '',
      loading: true,
      invoices_fields,
      invoices: [],
      billStatusOptions: ['Καμία επιλογή'],
      selectedBillOption: 'Καμία επιλογή',
      selectedOption: 'Καμία επιλογή',
      statusOptions: ['Καμία επιλογή'],
      dataReady: false,
      certifications: [],
      fields: [
        {key: 'key', label: 'Πεδίο'},
        {key: 'value', label: 'Τιμή'},
      ],
      cases_fields: [
        {
          key: 'case_code', 
          label: 'Αριθμός Υπόθεσης', 
          sorter: true, 
          filter: true
        },
        {
          key: 'next_visit', 
          label: 'Επόμενη Επίσκεψη', 
          sorter: true, 
          filter: true
        },
        {
          key: 'status', 
          label: 'Κατάσταση', 
          sorter: false, 
          filter: true
        },
        {
          key: 'service', 
          label: 'Πρότυπο', 
          sorter: true, 
          filter: true
        },
        {
          key: 'service_subcategories', 
          label: 'Υποκατηγορία', 
          sorter: true, 
          filter: true
        },
        {
          key: 'bill_status', 
          label: 'Τιμολόγιο', 
          sorter: true, 
          filter: true
        },
        { 
          key: 'edit', 
          label: '', 
          sorter: false, 
          filter: false
        },
      ],
      services_fields: [
        {
          key: 'name',
          label: 'Υπηρεσία',
        },
        {
          key: 'price_service',
          label: 'Αμοιβή Προτύπου',
        },
        {
          key: 'consultant',
          label: 'Σύμβουλος',
        },
        {
          key: 'price_consultant_seller',
          label: 'Αμοιβή Συμβούλου',
        },
        {
          key: 'subcontractor',
          label: 'Υπεργολάβος',
        },
        {
          key: 'price_subcontractor',
          label: 'Αμοιβή Υπεργολάβου',
        },
      ],
      certifications_fields: [
        {
          key: 'service', 
          label: 'Υπηρεσία', 
          sorter: true, 
          filter: true
        },
        {
          key: 'certification_date', 
          label: 'Ημερομηνία Έκδοσης', 
          sorter: true, 
          filter: true
        },
        {
          key: 'expiration_date', 
          label: 'Ημερομηνία Λήξης', 
          sorter: true, 
          filter: true
        },
        { 
          key: 'edit', 
          label: '', 
          sorter: false, 
          filter: false
        }
      ],
      payment_options: [ 'Απλήρωτο', 'Μερική εξόφληση', 'Ολική εξόφληση', 'Επιταγή']
    }
  },
  computed: {
    filteredItems() {
      if (this.selectedOption == "Καμία επιλογή" && this.selectedBillOption == "Καμία επιλογή") {
        return this.cases;
      }
      return this.cases.filter(item => {
        const status = item.status.name;
        const bill_status = item.bill_status;

        if (this.selectedOption == "Καμία επιλογή") {
          return bill_status == this.selectedBillOption;
        }

        if (this.selectedBillOption == "Καμία επιλογή") {
          return status == this.selectedOption;
        }

        return status == this.selectedOption && bill_status == this.selectedBillOption;
      })
    }
  },
  methods: {
    getClientData (id) {
      const client = clientsData.find((client, index) => index + 1 == id)
      const clientDetails = client ? Object.entries(client) : [['id', 'Not found']]
      return clientDetails.map(([key, value]) => { return { key, value } })
    },
    goBack() {
      this.$router.go(-1)
    },
    editCertLink (id) {
      return `/certifications/${id.toString()}/edit`
    },
    editCert ( id ) {
      const editLink = this.editCertLink( id );
      this.$router.push({path: editLink});
    },
    getAllServices(services) {
      let temp = [];
      let text = '';
      temp = services.map((item) => {return item.service.case_code;});
      text = temp.join(", ");
      return text;
    },
    getTotalPrice(services) {
      let sum = services.reduce(function (accumulator, item) {
        return accumulator + parseFloat(item.total_price)
      }, 0);
      return sum;
    },
    getSubcategory(subcategory) {
      let temp = [];
      let text = '';
      temp = subcategory.map((item) => {return item.name;});
      text = temp.join(", ");
      return text;
    },
    editCaseLink (id) {
      return `/cases/${id.toString()}/edit`
    },
    editClientLink (id) {
      return `/clients/${id.toString()}/edit`
    },
    showClient ( id ) {
      const clientLink = this.clientLink( id );
      this.$router.push({path: clientLink});
    },
    editClient () {
      const editLink = this.editClientLink( this.$route.params.id );
      this.$router.push({path: editLink});
    },
    editCase ( id ) {
      const editLink = this.editCaseLink( id );
      this.$router.push({path: editLink});
    },
    getClient() {
      let self = this;
      self.loading = true;
      axios.get('/api/clients/' + self.$route.params.id + '?token=' + localStorage.getItem("api_token"))
      .then(function (response) {
        //const items = response.data.clients;
        self.cases = response.data.cases.map((item) => {
          item.service = item.service.name;
          item.service_subcategories = self.getSubcategory(item.service_subcategories);
          item.bill_status = item.bill_status.name;
          return item;
        });
        self.statusOptions = ['Καμία επιλογή', ...new Set(self.cases.map(item => item.status.name))];
        self.selectedOption = self.statusOptions[0];

        self.billStatusOptions = ['Καμία επιλογή', ...new Set(self.cases.map(item => item.bill_status))];
        self.selectedBillOption = self.billStatusOptions[0];

        self.services = response.data.services.map((item) => {
          item.consultant = item.consultant ? item.consultant.name : '';
          return item;
        });
        self.signed_deal = response.data.signed_deal;

        if (response.data.consultant) {
          response.data.consultant = response.data.consultant.name;
        }

        self.certifications = response.data.certifications.map((item) => {
          item.service = item.service.name;
          return item;
        });

        self.invoices = response.data.invoices.map((item) => {
          return {
            document_number: item.document_number,
            service: self.getAllServices(item.invoices_cases),
            total_price: self.getTotalPrice(item.invoices_cases),
            remaining: parseFloat(self.getTotalPrice(item.invoices_cases)) - parseFloat(item.paid_amount),
            payment_status: item.payment_status,
            payment_comment: item.payment_comment,
          }
        });

        const items = Object.entries(response.data).map(([key, value]) => {return {key: key, value: value}});
        const keys = ["company", "company_en", "email_1", "email_2", "address", "contact_name", "phone_number_1", "phone_number_2", "fax", "countries", "notes", "website", "active", "town", "state", "postcode"];
        self.gen_items = items.filter((t) => keys.includes(t.key));

        self.title = self.gen_items.find((t) => t.key == "company").value;


        self.gen_items = self.gen_items.map((item) => {
          if (item.key == "company") {
            item.key = "Επωνυμία Οργανισμού (Ελληνικά):";
          } else if (item.key == "company_en") {
            item.key = "Επωνυμία Οργανισμού (Αγγλικά) - για πιστοποιητικό:";
          } else if (item.key == "email_1") {
            item.key = "E-mail Επικοινωνίας (1):";
          } else if (item.key == "email_2") {
            item.key = "E-mail Επικοινωνίας (2):";
          } else if (item.key == "address") {
            item.key = "Διεύθυνση Οργανισμού:";
          } else if (item.key == "contact_name") {
            item.key = "Υπεύθυνος Επικοινωνίας:";
          } else if (item.key == "phone_number_1") {
            item.key = "Τηλ. Επικοινωνίας (1):";
          } else if (item.key == "phone_number_2") {
            item.key = "Τηλ. Επικοινωνίας (2):";
          } else if (item.key == "fax") {
            item.key = "Fax:";
          } else if (item.key == "website") {
            item.key = "Ιστοσελίδα:";          
          } else if (item.key == "countries" && item.value) {
            item.key = "Χώρα:";
            item.value = item.value.name;
          } else if (item.key == "notes") {
            item.key = "Άλλες Πληροφορίες / Σχόλια:";
          } else if (item.key == "town") {
            item.key = "Πόλη:";
          } else if (item.key == "state") {
            item.key = "Νομός:";
          } else if (item.key == "postcode") {
            item.key = "Ταχυδρομικός Κώδικας:";
          } else if (item.key == "active") {
            item.key = "Ενεργός:";
            if (item.value == true) {
              item.value = "Ενεργός";
            } else {
              item.value = "Ανενεργός";
            }
          }

          return item;
        });

        const fin_keys = ["doy", "afm"];
        self.fin_items = items.filter((t) => fin_keys.includes(t.key));

        self.fin_items = self.fin_items.map((item) => {
          if (item.key == "afm") {
            item.key = "ΑΦΜ:";
          } else if (item.key == "doy") {
            item.key = "ΔΟΥ:";
          }

          return item;
        });

        self.dataReady = true;
        self.loading = false;

      }).catch(function (error) {
        console.log(error);
        self.loading = false;
        self.$router.push({ path: '/login' });
      });
    }
  },
  mounted: function(){
    let self = this;
    self.getClient();
  }
}

</script>
